import * as React from 'react';

const restrcitToRange = (min: number, max: number) => {
  return (num: number) => {
    if (num < min){
      return min;
    }
    if (num > max) {
      return max;
    }
    return num
  }
}

export class CursorCrossHairs extends React.Component {
  private ref: any;
  public state: {
    componentClientRect: {
      bottom?: number,
      height?: number,
      left?: number,
      right?: number,
      top?: number,
      width?: number,
      x?: number,
      y?: number,
    }
    cursorPosition: {
      x?: number,
      y?: number,
    }
  } = {
    componentClientRect: {},
    cursorPosition: {}
  };

  mouseMove(event: any){
    const {
      x: containerX = 0,
      y: containerY = 0,
      left: containerLeft = 0,
      top: containerTop = 0,
      bottom: containerBottom = 0,
      right: containerRight = 0,
    } = this.state.componentClientRect;
    this.setState({
      ...this.state,
      cursorPosition: {
        x: restrcitToRange(containerLeft, containerRight)(event.clientX) - containerX,
        y: restrcitToRange(containerTop, containerBottom)(event.clientY) - containerY,
      }
    })
  }

  componentDidMount(){
    this.setState({
      ...this.state,
      componentClientRect: this.ref.getBoundingClientRect()
    })
    window.addEventListener('mousemove', this.mouseMove.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener('mousemove', this.mouseMove.bind(this));
  }

  render(){
    return (
      <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10000, pointerEvents: 'none'}} ref={(ref) => this.ref = ref}>
        <div style={{width: '100vw', height: '1px', backgroundColor: 'white', position: 'absolute', top: this.state.cursorPosition.y}}></div>
        <div style={{height: '100vh', width: '1px', backgroundColor: 'white', position: 'absolute', left: this.state.cursorPosition.x}}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cursor-crosshairs.tsx